<template lang="pug">
#modal-delete-report
    el-dialog(
        :title="$t('relatorio_rastreabilidade.messages.traceabilityReport.modalDeleteReport.cancelReport')",
        width='610px',
        :visible='show',
        @close='closeDialog()'
    )
        h4.mb-4 {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.modalDeleteReport.irreversibleCancellation') }}
        p
            b {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.reportData.reportNumber') }}:
            |
            | {{ report.reportNumber }}

        el-form(label-position='top', size='small')
            .row
                .col-12
                    el-form-item
                        template(slot='label')
                            span {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.modalDeleteReport.justification') }}

                        el-input(
                            v-model='justificativa',
                            :maxlength='255',
                            :placeholder="$t('relatorio_rastreabilidade.messages.traceabilityReport.modalDeleteReport.justification')",
                            type='textarea',
                            resize='none',
                            :rows='2'
                        )
        .buttons.center-align
            BaseButton(size='mini', @click='closeDialog()')
                | {{ $t('mensagens.comuns.fechar') }}
            BaseButton(type='primary', size='mini', @click='cancelarReport')
                | {{ $t('mensagens.comuns.confirmar') }}
</template>

<script>
import RelatorioRastreabilidadeService from '@/services/RelatorioRastreabilidadeService.js';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'DeleteReport',

    components: {
        BaseButton
    },

    emits: ['cancelarReport'],

    props: {
        report: {
            type: Object,
            required: true
        },
        show: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            justificativa: null
        };
    },

    methods: {
        closeDialog() {
            this.justificativa = null;
            this.$emit('update:show', false);
        },

        async cancelarReport() {
            if (this.justificativa == null || this.justificativa.length === 0) {
                this.$notify.error({
                    message: this.$t('mensagens.operacao.notificacao.preenchaJustificativa')
                });
                return;
            }

            await RelatorioRastreabilidadeService.cancelReport(this.report.id, this.justificativa)
                .then(() => {
                    this.$notify.success({
                        message: this.$t('relatorio_rastreabilidade.messages.traceabilityReport.modalDeleteReport.success')
                    });
                    this.$emit('cancelarReport');
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('relatorio_rastreabilidade.messages.traceabilityReport.modalDeleteReport.error')
                    });
                })
                .finally(() => this.closeDialog());
        }
    }
};
</script>

<style lang="scss">
#modal-delete-report {

    .center-align {
        text-align: center;
        justify-content: space-between;
        display: flex;
    }

    h4.mb-4 {
        word-break: break-word;
        font-size: 14px !important;
    }

    .el-dialog__footer {
        margin-top: -30px;
        display: flex;
        justify-content: flex-start;
    }

    .mapa {
        height: 150px;
        border-radius: 4px;
        overflow: hidden;
        margin: -20px 0 20px 0;
    }

    .link {
        margin-left: 20px;
        cursor: pointer;

        i {
            display: inline-flex;
            vertical-align: bottom;
            font-style: normal;
            font-size: 13px;
        }
    }

    .margin-p {
        margin-bottom: 0;
    }
}
</style>
